module.exports = __webpack_public_path__ + "img/ch59.5a1c400a.png";